// Config for firebase

import Firebase from 'firebase'
const FireDb = Firebase.initializeApp({
  apiKey: 'AIzaSyC04Fn_6lTYxMQw_lJ66uwPRkrEv2F8tNU',
  authDomain: 'cloetta-staging.firebaseapp.com',
  databaseURL: 'https://cloetta-staging.firebaseio.com',
  projectId: 'cloetta-staging',
  storageBucket: 'cloetta-staging.appspot.com',
  messagingSenderId: '100586174413'
})

export default FireDb



// WEBPACK FOOTER //
// ./src/api/FireDb.js